import React from 'react';
import { iconSize } from './constants.mjs';

const withoutBoundingBoxWidth = {
  large: 18,
  medium: 14,
  small: 10,
  xSmall: 8
};
const DownloadIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? iconSize[size] : withoutBoundingBoxWidth[size];
    iconHeight = iconSize[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: iconWidth,
      height: iconHeight,
      viewBox: "0 0 30 30",
      preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
      fill: "none",
      ...others
    },
    /* @__PURE__ */ React.createElement("path", { d: "M22 22.6204H8V21.6204H22V22.6204Z", fill: "currentColor" }),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M18.1746 14.4618L18.8254 15.2211L15.5 18.0714V18.1204H15.4429L15 18.5L14.5571 18.1204H14.5V18.0714L11.1746 15.2211L11.8254 14.4618L14.5 16.754V7.12036H15.5V16.7539L18.1746 14.4618Z",
        fill: "currentColor"
      }
    )
  );
};
DownloadIcon.iconName = "DownloadIcon";

export { DownloadIcon };
